import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

export const CTestimonials = ({ id }) => {
  const [TestimonialsList, setTestimonialsList] = useState([]);
  const fetchData = async () => {
    try {
      const list = await corefetch(
        `Testimonial/GetTestimonialList?TestimonialId=${id}`
      );
      if (list && list.length > 0) {
        setTestimonialsList(list);
      } else {
        setTestimonialsList([]);
        console.error("No data found");
      }
    } catch (error) {
      setTestimonialsList([]);
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (TestimonialsList?.length) {
      $(".testimonials .owl-carousel").owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: false,
        nav: false,
        navText: [
          "<span class='lnr ti-angle-left'></span>",
          "<span class='lnr ti-angle-right'></span>",
        ],
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1000: {
            items: 1,
          },
        },
      });
    }
  }, [JSON.stringify(TestimonialsList)]);

  if (!TestimonialsList || TestimonialsList.length == 0) {
    return null;
  }

  return (
    <section className="testimonials section-padding">
      <div className="container">
        <div className="row mb-30">
          <div className="col-md-3">
            <div className="sub-title border-bot-light">
              What our client says
            </div>
          </div>
          <div className="col-md-9">
            <div className="section-title">Testimonials</div>
          </div>
        </div>
        <div
          id="testimonialCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          {/* Indicators */}
          <ol className="carousel-indicators">
            {TestimonialsList.map((_, index) => (
              <li
                key={index}
                data-bs-target="#testimonialCarousel"
                data-bs-slide-to={index}
                className={index == 0 ? "active" : ""}
              />
            ))}
          </ol>
          {/* Carousel Items */}
          <div className="carousel-inner">
            {TestimonialsList.map((testimonial, index) => (
              <div
                className={`carousel-item ${index == 0 ? "active" : ""}`}
                key={testimonial.id}
              >
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="img-holder">
                      <a
                        href={testimonial.galleryURL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="img-fluid rounded w-100 equal-height"
                          src={`${ImageURL}${testimonial.imagePath}`}
                          alt={testimonial.clientName}
                        />
                        <div className="hover-content">
                          <i className="ti-plus" />
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="testimonial-content">
                      <h3 style={{ textAlign: "center" }}>
                        {" "}
                        {testimonial.title}
                      </h3>
                      <p>{testimonial.description}</p>

                      <div className="wpo-testimonial-text-btm">
                        <h3 style={{ textAlign: "center" }}>
                          {testimonial.clientName}
                        </h3>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                            fontFamily: "Outfit, sans-serif",
                          }}
                        >
                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {testimonial.ballroomName}
                          </span>

                          <span style={{ margin: "0 5px" }}>-</span>

                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {new Date(testimonial.eventDate)
                              .toLocaleDateString("en-US", {
                                month: "short",
                                day: "2-digit",
                                year: "numeric",
                              })
                              .toUpperCase()}
                          </span>

                          <span style={{ margin: "0 5px" }}>-</span>

                          <span
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {testimonial.reviewsFrom}
                          </span>
                        </div>
                        <div style={{ textAlign: "center", marginTop: "30px" }}>
                          <a
                            href={testimonial.galleryURL}
                            class="butn-dark2"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: "inline-block",
                              width: "200px",
                              textAlign: "center",
                            }}
                          >
                            <span>View Gallery</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* Carousel Controls */}
          {/* <a
            className="carousel-control-prev"
            href="#testimonialCarousel"
            role="button"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="visually-hidden">Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#testimonialCarousel"
            role="button"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="visually-hidden">Next</span>
          </a> */}
        </div>
      </div>
    </section>
  );
};
